<template>
  <div>
    <PageHeader :title="tituloPagina.title" />

    <AcompanhamentoMensalPage />
  </div>
</template>

<script lang="js">
import PageHeader from "@/components/page-header";
import AcompanhamentoMensalPage from "@/features/campanha/acompanhamento-mensal/pages/AcompanhamentoMensalPage.vue";

export default {
  name: "AcompanhamentoMensal",

  components: {
    PageHeader,
    AcompanhamentoMensalPage
  },

  data() {
    return {
      tituloPagina: {
        type: String,
        title: "Acompanhamento Mensal cooperado"
      }
    };
  },

  created() {
    this.$root.$on("campanha:titulo-proced", this.atualizarTitulo);
  },

  beforeDestroy() {
    this.$root.$off("campanha:titulo-proced", this.atualizarTitulo);
  },

  methods: {
    atualizarTitulo(titulo) {
      this.tituloPagina.title = titulo || "Acompanhamento Mensal cooperado";
    }
  }
};
</script>
